import { Pipe, PipeTransform } from '@angular/core';
import { formatToman } from '../../common/utils/string';

@Pipe({ name: 'ngxToman' })
export class TomanPipe implements PipeTransform {
  transform(value: any, fallback: string = '-'): string {
    return formatToman(value, fallback);
  }
}
